import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { RootState } from '../../store';
import { UserRole } from 'susy-common/models';
import { IAdminDocument } from '../admin/supervisors/interfaces';
import HelpDocumentItem from './helpDocumentItem/HelpDocumentItem';

interface HelpDocumentsListProps {
    userRole: UserRole | undefined;
    adminDocuments: Array<IAdminDocument>;
}

export interface HelpDocument {
    fileName: string;
    fileOriginalName: string;
}

class HelpDocumentsList extends React.Component<HelpDocumentsListProps> {
    render = () => {
        return (
            <Row>
                <Col xs={12} lg={7}>
                    {this.props.adminDocuments.map(
                        (adminDocument: IAdminDocument, index) => (
                            <React.Fragment key={index}>
                                <HelpDocumentItem
                                    adminDocument={adminDocument}
                                />
                            </React.Fragment>
                        )
                    )}
                </Col>
            </Row>
        );
    };
}

const mapStateToProps = (state: RootState) => ({
    currentUser: state.auth.currentUser,
});

export default connect(mapStateToProps, {})(HelpDocumentsList);
